import { BaseMapper } from '@/core/mapper';

import { Vendor } from '@/core/vendor';

import { WorkerOneTimePass } from '@/core/worker-one-time-pass';

const schema = {
  allowed_transitions: {
    parseFrom: 'relationships.user.meta.allowed_transitions',
    omitFromRequest: true,
  },
  email: {
    label: 'Email',
    parseFrom: 'relationships.user.attributes.email',
  },
  first_name: {
    label: 'First name',
    parseFrom: 'relationships.user.attributes.first_name',
  },
  last_name: {
    label: 'Last name',
    parseFrom: 'relationships.user.attributes.last_name',
  },
  mobile_phone_number: {
    label: 'Mobile number',
    parseFrom: 'attributes.mobile_phone_number',
    omitFromRequest: true,
  },
  worker_one_time_passes: {
    fromResponse: entity => _.get(entity, 'relationships.worker_one_time_passes', []).map(wotp => new WorkerOneTimePass(wotp)),
    omitFromRequest: true,
  },
  status: {
    label: 'User status',
    parseFrom: 'relationships.user.meta.current_state',
    omitFromRequest: true,
  },
  uuid: {
    parseFrom: 'attributes.uuid',
  },
  vendor: {
    fromResponse: (entity) => {
      const vendor = _.get(entity, 'relationships.vendor');
      return vendor && new Vendor(vendor);
    },
    omitFromRequest: true,
  },
};

class Worker extends BaseMapper {
  constructor(entity = null) {
    super({ entity, schema });
  }
}

Worker.schema = schema;

export default Worker;
